import $ from "jquery";

async function init() {
  // Build filters from all content
  $(".js-filter-content").each(function() {
    const filters = $(this)
      .find("> div")
      .map(function() {
        return $(this).data("type");
      })
      .get()
      .join(",");

    let types = filters.split(",");

    const uniqueTypes = new Set(types);
    types = Array.from(uniqueTypes).sort();
    types.push(types.splice(types.indexOf("Other"), 1)[0]);

    const list = $(".js-filter-items");

    $.each(types, (i: number) => {
      $("<li />")
        .addClass("filter__item js-filter-item")
        .attr("data-filter", types[i])
        .html(
          types[i] +
            '<span class="filter__count">(' +
            $(`[data-type='${types[i]}']`).length +
            ")</span>"
        )
        .appendTo(list);
    });
  });

  // Get selected category from query
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams?: any, prop?: string) => searchParams.get(prop)
  });
  const category = params.category;

  function doFilter(e?: any, f?: any) {
    $(".js-filter-item").removeClass("active");
    $(e).addClass("active");

    if (f === "*") {
      $(".js-filter-content > div")
        .show()
        .addClass("visible-item");
    } else {
      $(".js-filter-content > div")
        .hide()
        .removeClass("visible-item");
      $('.js-filter-content > div[data-type*="' + f + '"')
        .show()
        .addClass("visible-item");
    }
  }

  if (category != null) {
    doFilter(".js-filter-item[data-filter='" + category + "']", category);
  }

  $(".js-filter-item").on("click", function() {
    const filter = $(this).data("filter");
    doFilter(this, filter);
  });
}

export default { init };
